export const APP_SIDEBAR_WIDTH = 236;
